import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NoMealsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"no_meals"}/>
}
